/**
 * Component for displaying information about messy situations and introducing a cleaning product.
 *
 * @component
 * @param {Object} props - The properties passed to the MessesHappen component.
 * @param {Object} props.data - Data containing information about messy situations and the cleaning product.
 * @param {Object} props.commonAssets - Common assets used in the component.
 * @returns {JSX.Element} - MessesHappen component.
 */

import AddToCartButton from "@/components/common/AddToCartButton";
import Image from "next/image";
import Link from "next/link";
import styles from "./MessesHappen.module.scss";
import PopcornDetection from "./PopcornDetection";
import maticRobotThumbnail from "@assets/images/homepage/matic_robot_thumbnail.webp";

function MessesHappen({ data, commonAssets }) {
  return (
    <>
      <section className="relative lg:block hidden">
        <div className="h-full w-full">
          <div className="h-full relative">
            <PopcornDetection data={data} />
            <div className="w-full m-auto px-[100px] xl:px-[160px] max-w-[1440px]">
              <div className={`aspect-w-59 aspect-h-8`}>
                <div
                  className={`px-[37px] py-[44px] ${styles.outerBox} rounded-16 lg:flex lg:items-center lg:justify-center lg:gap-[25px] text-center`}
                >
                  <div className="flex justify-center">
                    <Image
                      src={maticRobotThumbnail}
                      width={119}
                      height={61}
                      alt="matic 2"
                    />
                  </div>
                  <h5 className="lg:mt-0 lg:mb-0 mt-[32px] mb-[16px]">
                    {data?.messesHappenTitle}
                  </h5>
                  <Link
                    href="/product"
                    className="btn-primary eyebrow-bold lg:mt-0 mt-4 transition-colors inline-flex rounded-full"
                    title={commonAssets?.reserveYourMaticCta}
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mx-[5%] mt-[80px] lg:hidden block">
        <div
          className={`px-[37px] py-[44px] ${styles.outerBox} rounded-8 lg:flex lg:items-center lg:justify-center lg:gap-[25px] text-center`}
        >
          <div className="flex justify-center">
            <Image
              src={`https:${data?.messesHappenMaticRobotThumbnail?.fields?.file?.url}`}
              width={119}
              height={61}
              alt="matic 2"
            />
          </div>
          <h5 className="mr-[2.5%] ml-[4%] lg:mt-0 lg:mb-0 mt-[32px] mb-[16px]">
            {data?.messesHappenMobileTitle1}
            <br /> {data?.messesHappenMobileTitle2}
          </h5>
          <Link
            href="/product"
            className="btn-primary border border-primary eyebrow-bold py-4 px-10 mt-4 transition-colors inline-flex rounded-full whitespace-nowrap"
            title="Learn More"
          >
            Learn More
          </Link>
        </div>
      </section>
    </>
  );
}

export default MessesHappen;
